(function () {
  const ratingTexts = {
    1: "Terrible",
    2: "Poor",
    3: "Average",
    4: "Great",
    5: "Excellent",
  };

  const icons = {
    pin: '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" style="display:inline-block; vertical-align:middle;"><path d="M12 21s-8-7.5-8-12a8 8 0 1 1 16 0c0 4.5-8 12-8 12z"/><circle cx="12" cy="9" r="2.5"/></svg>',
    check: '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#059669" stroke-width="2.5" style="display:inline-block; vertical-align:middle;"><polyline points="20 6 9 17 4 12"/></svg>',
    close: '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>',
    camera: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2"><rect x="3" y="7" width="18" height="14"/><circle cx="12" cy="14" r="4"/><path d="M7 7V5h10v2"/></svg>',
    user: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>',
    thumb: '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" style="display:inline-block; vertical-align:middle;"><path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"/></svg>',
    lock: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="1.5" style="margin-bottom:8px;"><rect x="3" y="11" width="18" height="11" rx="1"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>',
    successCheck: '<svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="1.5"><circle cx="12" cy="12" r="10"/><polyline points="16 9 10 15 8 13"/></svg>',
    pending: '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#b45309" stroke-width="2" style="display:inline-block; vertical-align:middle;"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>',
  };

  const RECOMMENDED_COUNTRIES = [
    { code: "PK", name: "Pakistan", flag: "🇵🇰", dial: "+92" },
    { code: "US", name: "United States", flag: "🇺🇸", dial: "+1" },
    { code: "GB", name: "United Kingdom", flag: "🇬🇧", dial: "+44" },
    { code: "AE", name: "United Arab Emirates", flag: "🇦🇪", dial: "+971" },
    { code: "SA", name: "Saudi Arabia", flag: "🇸🇦", dial: "+966" },
    { code: "CA", name: "Canada", flag: "🇨🇦", dial: "+1" },
    { code: "AU", name: "Australia", flag: "🇦🇺", dial: "+61" },
    { code: "DE", name: "Germany", flag: "🇩🇪", dial: "+49" },
    { code: "FR", name: "France", flag: "🇫🇷", dial: "+33" },
    { code: "QA", name: "Qatar", flag: "🇶🇦", dial: "+974" },
    { code: "KW", name: "Kuwait", flag: "🇰🇼", dial: "+965" },
    { code: "BH", name: "Bahrain", flag: "🇧🇭", dial: "+973" },
    { code: "OM", name: "Oman", flag: "🇴🇲", dial: "+968" },
    { code: "SG", name: "Singapore", flag: "🇸🇬", dial: "+65" },
    { code: "MY", name: "Malaysia", flag: "🇲🇾", dial: "+60" },
    { code: "IN", name: "India", flag: "🇮🇳", dial: "+91" },
  ];

  const ALL_COUNTRIES = [
    { code: "AF", name: "Afghanistan", flag: "🇦🇫" },
    { code: "AL", name: "Albania", flag: "🇦🇱" },
    { code: "DZ", name: "Algeria", flag: "🇩🇿" },
    { code: "AD", name: "Andorra", flag: "🇦🇩" },
    { code: "AO", name: "Angola", flag: "🇦🇴" },
    { code: "AG", name: "Antigua and Barbuda", flag: "🇦🇬" },
    { code: "AR", name: "Argentina", flag: "🇦🇷" },
    { code: "AM", name: "Armenia", flag: "🇦🇲" },
    { code: "AU", name: "Australia", flag: "🇦🇺" },
    { code: "AT", name: "Austria", flag: "🇦🇹" },
    { code: "AZ", name: "Azerbaijan", flag: "🇦🇿" },
    { code: "BS", name: "Bahamas", flag: "🇧🇸" },
    { code: "BH", name: "Bahrain", flag: "🇧🇭" },
    { code: "BD", name: "Bangladesh", flag: "🇧🇩" },
    { code: "BB", name: "Barbados", flag: "🇧🇧" },
    { code: "BY", name: "Belarus", flag: "🇧🇾" },
    { code: "BE", name: "Belgium", flag: "🇧🇪" },
    { code: "BZ", name: "Belize", flag: "🇧🇿" },
    { code: "BJ", name: "Benin", flag: "🇧🇯" },
    { code: "BT", name: "Bhutan", flag: "🇧🇹" },
    { code: "BO", name: "Bolivia", flag: "🇧🇴" },
    { code: "BA", name: "Bosnia and Herzegovina", flag: "🇧🇦" },
    { code: "BW", name: "Botswana", flag: "🇧🇼" },
    { code: "BR", name: "Brazil", flag: "🇧🇷" },
    { code: "BN", name: "Brunei", flag: "🇧🇳" },
    { code: "BG", name: "Bulgaria", flag: "🇧🇬" },
    { code: "BF", name: "Burkina Faso", flag: "🇧🇫" },
    { code: "BI", name: "Burundi", flag: "🇧🇮" },
    { code: "KH", name: "Cambodia", flag: "🇰🇭" },
    { code: "CM", name: "Cameroon", flag: "🇨🇲" },
    { code: "CA", name: "Canada", flag: "🇨🇦" },
    { code: "CV", name: "Cape Verde", flag: "🇨🇻" },
    { code: "CL", name: "Chile", flag: "🇨🇱" },
    { code: "CN", name: "China", flag: "🇨🇳" },
    { code: "CO", name: "Colombia", flag: "🇨🇴" },
    { code: "CR", name: "Costa Rica", flag: "🇨🇷" },
    { code: "HR", name: "Croatia", flag: "🇭🇷" },
    { code: "CY", name: "Cyprus", flag: "🇨🇾" },
    { code: "CZ", name: "Czech Republic", flag: "🇨🇿" },
    { code: "DK", name: "Denmark", flag: "🇩🇰" },
    { code: "DJ", name: "Djibouti", flag: "🇩🇯" },
    { code: "DM", name: "Dominica", flag: "🇩🇲" },
    { code: "DO", name: "Dominican Republic", flag: "🇩🇴" },
    { code: "EC", name: "Ecuador", flag: "🇪🇨" },
    { code: "EG", name: "Egypt", flag: "🇪🇬" },
    { code: "SV", name: "El Salvador", flag: "🇸🇻" },
    { code: "EE", name: "Estonia", flag: "🇪🇪" },
    { code: "ET", name: "Ethiopia", flag: "🇪🇹" },
    { code: "FJ", name: "Fiji", flag: "🇫🇯" },
    { code: "FI", name: "Finland", flag: "🇫🇮" },
    { code: "FR", name: "France", flag: "🇫🇷" },
    { code: "GE", name: "Georgia", flag: "🇬🇪" },
    { code: "DE", name: "Germany", flag: "🇩🇪" },
    { code: "GH", name: "Ghana", flag: "🇬🇭" },
    { code: "GR", name: "Greece", flag: "🇬🇷" },
    { code: "HK", name: "Hong Kong", flag: "🇭🇰" },
    { code: "HU", name: "Hungary", flag: "🇭🇺" },
    { code: "IS", name: "Iceland", flag: "🇮🇸" },
    { code: "IN", name: "India", flag: "🇮🇳" },
    { code: "ID", name: "Indonesia", flag: "🇮🇩" },
    { code: "IR", name: "Iran", flag: "🇮🇷" },
    { code: "IQ", name: "Iraq", flag: "🇮🇶" },
    { code: "IE", name: "Ireland", flag: "🇮🇪" },
    { code: "IL", name: "Israel", flag: "🇮🇱" },
    { code: "IT", name: "Italy", flag: "🇮🇹" },
    { code: "JM", name: "Jamaica", flag: "🇯🇲" },
    { code: "JP", name: "Japan", flag: "🇯🇵" },
    { code: "JO", name: "Jordan", flag: "🇯🇴" },
    { code: "KZ", name: "Kazakhstan", flag: "🇰🇿" },
    { code: "KE", name: "Kenya", flag: "🇰🇪" },
    { code: "KW", name: "Kuwait", flag: "🇰🇼" },
    { code: "KG", name: "Kyrgyzstan", flag: "🇰🇬" },
    { code: "LV", name: "Latvia", flag: "🇱🇻" },
    { code: "LB", name: "Lebanon", flag: "🇱🇧" },
    { code: "LT", name: "Lithuania", flag: "🇱🇹" },
    { code: "LU", name: "Luxembourg", flag: "🇱🇺" },
    { code: "MY", name: "Malaysia", flag: "🇲🇾" },
    { code: "MV", name: "Maldives", flag: "🇲🇻" },
    { code: "MT", name: "Malta", flag: "🇲🇹" },
    { code: "MU", name: "Mauritius", flag: "🇲🇺" },
    { code: "MX", name: "Mexico", flag: "🇲🇽" },
    { code: "MC", name: "Monaco", flag: "🇲🇨" },
    { code: "MA", name: "Morocco", flag: "🇲🇦" },
    { code: "NP", name: "Nepal", flag: "🇳🇵" },
    { code: "NL", name: "Netherlands", flag: "🇳🇱" },
    { code: "NZ", name: "New Zealand", flag: "🇳🇿" },
    { code: "NG", name: "Nigeria", flag: "🇳🇬" },
    { code: "NO", name: "Norway", flag: "🇳🇴" },
    { code: "OM", name: "Oman", flag: "🇴🇲" },
    { code: "PK", name: "Pakistan", flag: "🇵🇰" },
    { code: "PS", name: "Palestine", flag: "🇵🇸" },
    { code: "PA", name: "Panama", flag: "🇵🇦" },
    { code: "PE", name: "Peru", flag: "🇵🇪" },
    { code: "PH", name: "Philippines", flag: "🇵🇭" },
    { code: "PL", name: "Poland", flag: "🇵🇱" },
    { code: "PT", name: "Portugal", flag: "🇵🇹" },
    { code: "QA", name: "Qatar", flag: "🇶🇦" },
    { code: "RO", name: "Romania", flag: "🇷🇴" },
    { code: "RU", name: "Russia", flag: "🇷🇺" },
    { code: "SA", name: "Saudi Arabia", flag: "🇸🇦" },
    { code: "RS", name: "Serbia", flag: "🇷🇸" },
    { code: "SG", name: "Singapore", flag: "🇸🇬" },
    { code: "SK", name: "Slovakia", flag: "🇸🇰" },
    { code: "SI", name: "Slovenia", flag: "🇸🇮" },
    { code: "ZA", name: "South Africa", flag: "🇿🇦" },
    { code: "KR", name: "South Korea", flag: "🇰🇷" },
    { code: "ES", name: "Spain", flag: "🇪🇸" },
    { code: "LK", name: "Sri Lanka", flag: "🇱🇰" },
    { code: "SE", name: "Sweden", flag: "🇸🇪" },
    { code: "CH", name: "Switzerland", flag: "🇨🇭" },
    { code: "TW", name: "Taiwan", flag: "🇹🇼" },
    { code: "TH", name: "Thailand", flag: "🇹🇭" },
    { code: "TN", name: "Tunisia", flag: "🇹🇳" },
    { code: "TR", name: "Turkey", flag: "🇹🇷" },
    { code: "UA", name: "Ukraine", flag: "🇺🇦" },
    { code: "AE", name: "United Arab Emirates", flag: "🇦🇪" },
    { code: "GB", name: "United Kingdom", flag: "🇬🇧" },
    { code: "US", name: "United States", flag: "🇺🇸" },
    { code: "UY", name: "Uruguay", flag: "🇺🇾" },
    { code: "UZ", name: "Uzbekistan", flag: "🇺🇿" },
    { code: "VN", name: "Vietnam", flag: "🇻🇳" },
    { code: "YE", name: "Yemen", flag: "🇾🇪" },
    { code: "ZW", name: "Zimbabwe", flag: "🇿🇼" },
  ];

  function getCountryFlag(countryName) {
    if (!countryName) return "";
    const clean = String(countryName).trim().toLowerCase();
    const found = RECOMMENDED_COUNTRIES.find((c) => c.name.toLowerCase() === clean || c.code.toLowerCase() === clean) ||
                  ALL_COUNTRIES.find((c) => c.name.toLowerCase() === clean || c.code.toLowerCase() === clean);
    if (found) return found.flag;
    if (clean.includes("pakistan")) return "🇵🇰";
    if (clean.includes("united states") || clean === "usa" || clean === "us") return "🇺🇸";
    if (clean.includes("united kingdom") || clean === "uk" || clean === "great britain") return "🇬🇧";
    if (clean.includes("emirates") || clean === "uae") return "🇦🇪";
    if (clean.includes("saudi")) return "🇸🇦";
    if (clean.includes("canada")) return "🇨🇦";
    if (clean.includes("australia")) return "🇦🇺";
    if (clean.includes("germany")) return "🇩🇪";
    if (clean.includes("france")) return "🇫🇷";
    if (clean.includes("qatar")) return "🇶🇦";
    if (clean.includes("india")) return "🇮🇳";
    return "";
  }

  const COUNTRY_DIAL_MAP = {
    "pakistan": "+92", "united states": "+1", "usa": "+1", "united kingdom": "+44", "uk": "+44",
    "united arab emirates": "+971", "uae": "+971", "saudi arabia": "+966", "canada": "+1",
    "australia": "+61", "germany": "+49", "france": "+33", "qatar": "+974", "kuwait": "+965",
    "bahrain": "+973", "oman": "+968", "singapore": "+65", "malaysia": "+60", "india": "+91",
    "afghanistan": "+93", "albania": "+355", "algeria": "+213", "andorra": "+376", "angola": "+244",
    "argentina": "+54", "armenia": "+374", "austria": "+43", "azerbaijan": "+994", "bahamas": "+1-242",
    "bangladesh": "+880", "barbados": "+1-246", "belarus": "+375", "belgium": "+32", "belize": "+501",
    "benin": "+229", "bhutan": "+975", "bolivia": "+591", "bosnia and herzegovina": "+387",
    "botswana": "+267", "brazil": "+55", "brunei": "+673", "bulgaria": "+359", "cambodia": "+855",
    "cameroon": "+237", "chile": "+56", "china": "+86", "colombia": "+57", "costa rica": "+506",
    "croatia": "+385", "cyprus": "+357", "czech republic": "+420", "denmark": "+45", "egypt": "+20",
    "estonia": "+372", "finland": "+358", "georgia": "+995", "ghana": "+233", "greece": "+30",
    "hong kong": "+852", "hungary": "+36", "iceland": "+354", "indonesia": "+62", "iran": "+98",
    "iraq": "+964", "ireland": "+353", "italy": "+39", "japan": "+81", "jordan": "+962",
    "kazakhstan": "+7", "kenya": "+254", "south korea": "+82", "lebanon": "+961", "luxembourg": "+352",
    "maldives": "+960", "mexico": "+52", "morocco": "+212", "nepal": "+977", "netherlands": "+31",
    "new zealand": "+64", "nigeria": "+234", "norway": "+47", "philippines": "+63", "poland": "+48",
    "portugal": "+351", "romania": "+40", "russia": "+7", "south africa": "+27", "spain": "+34",
    "sri lanka": "+94", "sweden": "+46", "switzerland": "+41", "taiwan": "+886", "thailand": "+66",
    "turkey": "+90", "ukraine": "+380", "vietnam": "+84", "yemen": "+967"
  };

  function getCountryDialCode(name) {
    if (!name) return "+92";
    const clean = String(name).toLowerCase().trim();
    if (COUNTRY_DIAL_MAP[clean]) return COUNTRY_DIAL_MAP[clean];
    for (const [k, v] of Object.entries(COUNTRY_DIAL_MAP)) {
      if (clean.includes(k) || k.includes(clean)) return v;
    }
    return "+92";
  }

  const initialVerifiedReviews = [];

  function renderStars(rating, max = 5) {
    let html = "";
    for (let i = 1; i <= max; i++) {
      if (i <= rating) {
        html += '<span style="color:#e5a00d;">★</span>';
      } else {
        html += '<span style="color:#d1d5db;">☆</span>';
      }
    }
    return html;
  }

  function timeAgo(dateString) {
    const date = new Date(dateString);
    const now = new Date();
    const diffDays = Math.floor((now - date) / (1000 * 60 * 60 * 24));
    if (diffDays === 0) return "TODAY";
    if (diffDays === 1) return "YESTERDAY";
    if (diffDays < 30) return `${diffDays} DAYS AGO`;
    if (diffDays < 365) return `${Math.floor(diffDays / 30)} MONTHS AGO`;
    return `${Math.floor(diffDays / 365)} YEARS AGO`;
  }

  function initCustomerReviewSection(container) {
    const shop = container.dataset.shop || window.Shopify?.shop || "noorekhas.com";
    const productId = container.dataset.productId || "";
    const productTitle = container.dataset.productTitle || "";
    const productHandle = container.dataset.productHandle || "";
    const rawApiUrl = container.dataset.apiUrl || "";

    function getEndpointUrls(base) {
      let clean = (base || "").trim().replace(/\/+$/, "");
      if (!clean || clean.includes("trycloudflare.com")) {
        clean = "/apps/reviews";
      }
      if (clean.endsWith("/api/reviews") || clean.endsWith("/apps/reviews")) {
        return {
          reviewsUrl: clean,
          helpfulUrl: `${clean}/helpful`,
        };
      }
      return {
        reviewsUrl: `${clean}/api/reviews`,
        helpfulUrl: `${clean}/api/reviews/helpful`,
      };
    }

    const { reviewsUrl, helpfulUrl } = getEndpointUrls(rawApiUrl);

    const customerLoggedIn = container.dataset.customerLoggedIn === "true";
    const customerName = container.dataset.customerName || "";
    const customerEmail = container.dataset.customerEmail || "";
    const loginUrl = container.dataset.loginUrl || `/account/login?return_url=${encodeURIComponent(window.location.pathname)}`;

    const storageKey = `noorekhaas_persistent_reviews_${shop}`;
    const votesKey = `noorekhaas_voted_reviews_${shop}`;

    // Persistent storage initialization
    function getStoredReviews() {
      try {
        const raw = localStorage.getItem(storageKey);
        if (raw) {
          const parsed = JSON.parse(raw);
          if (Array.isArray(parsed)) {
            return parsed;
          }
        }
      } catch (e) {
        console.warn("Could not read localStorage reviews", e);
      }
      localStorage.setItem(storageKey, JSON.stringify(initialVerifiedReviews));
      return initialVerifiedReviews;
    }

    function saveStoredReviews(revs) {
      try {
        localStorage.setItem(storageKey, JSON.stringify(revs));
      } catch (e) {
        console.warn("Could not write localStorage reviews", e);
      }
    }

    function getVotedIds() {
      try {
        return JSON.parse(localStorage.getItem(votesKey) || "[]");
      } catch (e) {
        return [];
      }
    }

    function saveVotedId(id) {
      try {
        const voted = getVotedIds();
        if (!voted.includes(id)) {
          voted.push(id);
          localStorage.setItem(votesKey, JSON.stringify(voted));
        }
      } catch (e) {}
    }

    let currentFilter = "all";
    let currentSort = "newest";
    let selectedRating = 5;
    let avatarBase64 = null;
    let productPhotoBase64 = null;

    container.innerHTML = `
      <div class="cr-container">
        <!-- Loading Skeleton -->
        <div id="cr-loading" style="text-align:center; padding:40px; color:#777777; font-size:11px; letter-spacing:1.5px; text-transform:uppercase;">
          <div>LOADING VERIFIED REVIEWS...</div>
        </div>
        <div id="cr-app-content" style="display:none;"></div>
      </div>

      <!-- Auth Gate Required Modal -->
      <div id="cr-auth-modal-overlay" class="cr-modal-overlay">
        <div class="cr-modal" style="max-width:460px; text-align:center; padding:36px 28px;">
          <div style="margin-bottom:12px;">${icons.lock}</div>
          <h3 class="cr-modal-title" style="margin-bottom:10px;">AUTHENTICATION REQUIRED</h3>
          <p style="font-size:11px; color:#555555; line-height:1.7; letter-spacing:0.3px; margin:0 0 24px 0;">
            To maintain review authenticity and verified buyer protection, please sign in or create an account before writing a review.
          </p>
          <div style="display:flex; flex-direction:column; gap:10px;">
            <a href="${loginUrl}" class="cr-btn-submit" style="text-decoration:none; display:block; text-align:center;">
              SIGN IN / CREATE ACCOUNT
            </a>
            <button type="button" id="cr-auth-close-btn" class="cr-filter-tag" style="width:100%; padding:12px; border:1px solid #000000; background:#ffffff; color:#000000;">
              CANCEL
            </button>
          </div>
        </div>
      </div>

      <!-- Write Review Modal -->
      <div id="cr-modal-overlay" class="cr-modal-overlay">
        <div class="cr-modal">
          <div class="cr-modal-header">
            <h3 class="cr-modal-title">WRITE A REVIEW</h3>
            <button id="cr-modal-close" class="cr-modal-close" type="button" aria-label="Close">${icons.close}</button>
          </div>

          <form id="cr-review-form">
            <!-- Star Rating Picker -->
            <div class="cr-star-picker-container">
              <label class="cr-label">OVERALL RATING</label>
              <div class="cr-star-picker" id="cr-star-picker">
                <button type="button" class="cr-star-picker-btn active" data-val="1">★</button>
                <button type="button" class="cr-star-picker-btn active" data-val="2">★</button>
                <button type="button" class="cr-star-picker-btn active" data-val="3">★</button>
                <button type="button" class="cr-star-picker-btn active" data-val="4">★</button>
                <button type="button" class="cr-star-picker-btn active" data-val="5">★</button>
              </div>
              <div class="cr-rating-hint" id="cr-rating-hint">EXCELLENT (5/5)</div>
            </div>

            <!-- Customer Name & Email -->
            <div class="cr-form-grid">
              <div class="cr-form-group">
                <label class="cr-label">YOUR NAME *</label>
                <input type="text" id="cr-input-name" class="cr-input" value="${customerName}" placeholder="SARAH JENKINS" required />
              </div>
              <div class="cr-form-group">
                <label class="cr-label">EMAIL ADDRESS <span class="cr-label-hint">(OPTIONAL)</span></label>
                <input type="email" id="cr-input-email" class="cr-input" value="${customerEmail}" placeholder="SARAH@EXAMPLE.COM" />
              </div>
            </div>

            <!-- City & Country Selection -->
            <div class="cr-form-grid">
              <div class="cr-form-group">
                <label class="cr-label" for="cr-input-country">COUNTRY *</label>
                <select id="cr-input-country" class="cr-input cr-select" required>
                  <option value="" disabled selected>— SELECT YOUR COUNTRY * —</option>
                  <optgroup label="★ RECOMMENDED COUNTRIES">
                    ${RECOMMENDED_COUNTRIES.map((c) => `<option value="${c.name}">${c.flag} ${c.name.toUpperCase()} (RECOMMENDED)</option>`).join("")}
                  </optgroup>
                  <optgroup label="ALL COUNTRIES (A–Z)">
                    ${ALL_COUNTRIES.map((c) => `<option value="${c.name}">${c.flag} ${c.name.toUpperCase()}</option>`).join("")}
                  </optgroup>
                </select>
              </div>
              <div class="cr-form-group">
                <label class="cr-label" for="cr-input-city">CITY *</label>
                <input type="text" id="cr-input-city" class="cr-input" placeholder="e.g. LAHORE, LONDON, NEW YORK" required />
              </div>
            </div>

            <!-- Customer Phone Number (Auto Dial Code by Country) -->
            <div class="cr-form-group">
              <label class="cr-label" for="cr-input-phone">PHONE NUMBER <span class="cr-label-hint">(FOR ORDER VERIFICATION)</span></label>
              <div class="cr-phone-input-wrap">
                <div class="cr-phone-prefix" id="cr-phone-prefix">+92 🇵🇰</div>
                <input type="tel" id="cr-input-phone" class="cr-phone-input" placeholder="300 1234567" />
              </div>
              <div class="cr-privacy-caption">🔒 Kept strictly private for order matching — never displayed publicly.</div>
            </div>

            <!-- Photo Uploads (Avatar & Product Photo) -->
            <div class="cr-upload-flex">
              <!-- Customer Avatar Upload -->
              <div class="cr-upload-card" id="cr-avatar-dropzone">
                <input type="file" id="cr-avatar-file" class="cr-file-input" accept="image/*" />
                <div id="cr-avatar-preview-wrap">
                  <div class="cr-upload-icon">${icons.user}</div>
                  <div class="cr-upload-text">UPLOAD PROFILE PHOTO</div>
                  <div class="cr-upload-subtext">OPTIONAL AVATAR</div>
                </div>
              </div>

              <!-- Product Photo Upload -->
              <div class="cr-upload-card" id="cr-product-photo-dropzone">
                <input type="file" id="cr-product-photo-file" class="cr-file-input" accept="image/*" />
                <div id="cr-product-photo-preview-wrap">
                  <div class="cr-upload-icon">${icons.camera}</div>
                  <div class="cr-upload-text">ADD PRODUCT PHOTO</div>
                  <div class="cr-upload-subtext">SHOW THE ITEM IN USE</div>
                </div>
              </div>
            </div>

            <!-- Review Title & Detailed Message -->
            <div class="cr-form-group">
              <label class="cr-label">REVIEW HEADLINE</label>
              <input type="text" id="cr-input-title" class="cr-input" placeholder="EXQUISITE QUALITY AND CRAFTSMANSHIP" />
            </div>

            <div class="cr-form-group">
              <label class="cr-label">DETAILED REVIEW *</label>
              <textarea id="cr-input-message" class="cr-textarea" rows="4" placeholder="Detail your experience with the fabric, fit, embroidery, and finish..." required></textarea>
            </div>

            <!-- Submit Button -->
            <button type="submit" id="cr-btn-submit" class="cr-btn-submit">
              SUBMIT CUSTOMER REVIEW
            </button>
          </form>

          <!-- Success State View with Moderation Notice -->
          <div id="cr-modal-success" style="display:none;" class="cr-success-state">
            <div class="cr-success-icon">${icons.successCheck}</div>
            <h3 style="font-size:13px; font-weight:600; letter-spacing:1.5px; text-transform:uppercase; color:#000000; margin:0 0 10px 0;">THANK YOU FOR YOUR REVIEW</h3>
            <p style="color:#555555; font-size:11px; letter-spacing:0.3px; line-height:1.7; margin:0 0 24px 0;">
              Thank you! Your review has been submitted successfully. It will be reviewed and published in the next few hours.
            </p>
            <button type="button" id="cr-modal-done-btn" class="cr-btn-submit" style="width:auto; padding:12px 32px;">CLOSE</button>
          </div>
        </div>
      </div>

      <!-- Lightbox Modal -->
      <div id="cr-lightbox" class="cr-lightbox-overlay">
        <button id="cr-lightbox-close" class="cr-lightbox-close" aria-label="Close">${icons.close}</button>
        <img id="cr-lightbox-img" class="cr-lightbox-img" src="" alt="Customer Photo" />
      </div>
    `;

    const appContent = container.querySelector("#cr-app-content");
    const loadingElem = container.querySelector("#cr-loading");
    const authModalOverlay = container.querySelector("#cr-auth-modal-overlay");
    const authCloseBtn = container.querySelector("#cr-auth-close-btn");
    const modalOverlay = container.querySelector("#cr-modal-overlay");
    const modalClose = container.querySelector("#cr-modal-close");
    const reviewForm = container.querySelector("#cr-review-form");
    const modalSuccess = container.querySelector("#cr-modal-success");
    const modalDoneBtn = container.querySelector("#cr-modal-done-btn");
    const starPicker = container.querySelector("#cr-star-picker");
    const ratingHint = container.querySelector("#cr-rating-hint");
    const lightbox = container.querySelector("#cr-lightbox");
    const lightboxImg = container.querySelector("#cr-lightbox-img");
    const lightboxClose = container.querySelector("#cr-lightbox-close");

    // Close auth modal
    if (authCloseBtn) {
      authCloseBtn.addEventListener("click", () => {
        authModalOverlay.classList.remove("active");
      });
    }
    if (authModalOverlay) {
      authModalOverlay.addEventListener("click", (e) => {
        if (e.target === authModalOverlay) authModalOverlay.classList.remove("active");
      });
    }

    // Avatar upload handler
    const avatarDropzone = container.querySelector("#cr-avatar-dropzone");
    const avatarFile = container.querySelector("#cr-avatar-file");
    const avatarPreviewWrap = container.querySelector("#cr-avatar-preview-wrap");

    if (avatarDropzone && avatarFile) {
      avatarDropzone.addEventListener("click", () => avatarFile.click());
      avatarFile.addEventListener("change", (e) => {
        const file = e.target.files[0];
        if (file) {
          const reader = new FileReader();
          reader.onload = (re) => {
            avatarBase64 = re.target.result;
            avatarPreviewWrap.innerHTML = `
              <img src="${avatarBase64}" class="cr-upload-preview cr-avatar-preview" alt="Avatar preview" />
              <div class="cr-upload-text" style="color:#000000;">PHOTO SELECTED</div>
              <div class="cr-upload-subtext">CLICK TO CHANGE</div>
            `;
          };
          reader.readAsDataURL(file);
        }
      });
    }

    // Product photo upload handler
    const productPhotoDropzone = container.querySelector("#cr-product-photo-dropzone");
    const productPhotoFile = container.querySelector("#cr-product-photo-file");
    const productPhotoPreviewWrap = container.querySelector("#cr-product-photo-preview-wrap");

    if (productPhotoDropzone && productPhotoFile) {
      productPhotoDropzone.addEventListener("click", () => productPhotoFile.click());
      productPhotoFile.addEventListener("change", (e) => {
        const file = e.target.files[0];
        if (file) {
          const reader = new FileReader();
          reader.onload = (re) => {
            productPhotoBase64 = re.target.result;
            productPhotoPreviewWrap.innerHTML = `
              <img src="${productPhotoBase64}" class="cr-upload-preview" alt="Product photo preview" />
              <div class="cr-upload-text" style="color:#000000;">PHOTO ATTACHED</div>
              <div class="cr-upload-subtext">CLICK TO CHANGE</div>
            `;
          };
          reader.readAsDataURL(file);
        }
      });
    }

    // Star Picker Interaction
    const starButtons = starPicker.querySelectorAll(".cr-star-picker-btn");
    starButtons.forEach((btn) => {
      btn.addEventListener("mouseenter", () => {
        const val = parseInt(btn.dataset.val, 10);
        starButtons.forEach((b) => {
          const bVal = parseInt(b.dataset.val, 10);
          b.classList.toggle("hovered", bVal <= val);
        });
        ratingHint.textContent = `${ratingTexts[val].toUpperCase()} (${val}/5)`;
      });

      btn.addEventListener("click", () => {
        selectedRating = parseInt(btn.dataset.val, 10);
        starButtons.forEach((b) => {
          const bVal = parseInt(b.dataset.val, 10);
          b.classList.toggle("active", bVal <= selectedRating);
        });
        ratingHint.textContent = `${ratingTexts[selectedRating].toUpperCase()} (${selectedRating}/5)`;
      });
    });

    starPicker.addEventListener("mouseleave", () => {
      starButtons.forEach((b) => {
        const bVal = parseInt(b.dataset.val, 10);
        b.classList.remove("hovered");
        b.classList.toggle("active", bVal <= selectedRating);
      });
      ratingHint.textContent = `${ratingTexts[selectedRating].toUpperCase()} (${selectedRating}/5)`;
    });

    // Open/Close Modal with Customer Auth Gate
    function handleWriteReviewClick() {
      // If customer is not authenticated, prompt login/registration modal
      if (!customerLoggedIn) {
        authModalOverlay.classList.add("active");
        return;
      }

      modalOverlay.classList.add("active");
      reviewForm.style.display = "block";
      modalSuccess.style.display = "none";
    }

    function closeModal() {
      modalOverlay.classList.remove("active");
    }

    modalClose.addEventListener("click", closeModal);
    modalDoneBtn.addEventListener("click", closeModal);
    modalOverlay.addEventListener("click", (e) => {
      if (e.target === modalOverlay) closeModal();
    });

    // Auto-update Phone Country Code & Prefix on Country Selection
    const countrySelect = container.querySelector("#cr-input-country");
    const phonePrefixEl = container.querySelector("#cr-phone-prefix");
    const phoneInputEl = container.querySelector("#cr-input-phone");

    if (countrySelect && phonePrefixEl) {
      countrySelect.addEventListener("change", () => {
        const selCountry = countrySelect.value;
        const dial = getCountryDialCode(selCountry);
        const flag = getCountryFlag(selCountry);
        phonePrefixEl.textContent = `${dial} ${flag}`;
        if (phoneInputEl) {
          if (dial === "+92") phoneInputEl.placeholder = "300 1234567";
          else if (dial === "+1") phoneInputEl.placeholder = "(555) 000-0000";
          else if (dial === "+44") phoneInputEl.placeholder = "7911 123456";
          else if (dial === "+971") phoneInputEl.placeholder = "50 123 4567";
          else if (dial === "+966") phoneInputEl.placeholder = "50 123 4567";
          else if (dial === "+91") phoneInputEl.placeholder = "98765 43210";
          else phoneInputEl.placeholder = "Enter phone number";
        }
      });
    }

    // Lightbox handlers
    function openLightbox(src) {
      lightboxImg.src = src;
      lightbox.classList.add("active");
    }

    lightboxClose.addEventListener("click", () => lightbox.classList.remove("active"));
    lightbox.addEventListener("click", (e) => {
      if (e.target === lightbox) lightbox.classList.remove("active");
    });

    // Fetch and render reviews from Persistent Storage + Server API
    async function loadReviews() {
      try {
        let stored = getStoredReviews();

        // Synchronize with server API via Shopify App Proxy / endpoint
        if (reviewsUrl) {
          try {
            const separator = reviewsUrl.includes("?") ? "&" : "?";
            const res = await fetch(`${reviewsUrl}${separator}shop=${encodeURIComponent(shop)}&t=${Date.now()}`);
            if (res.ok) {
              const apiData = await res.json();
              if (apiData && Array.isArray(apiData.reviews)) {
                stored = apiData.reviews;
                saveStoredReviews(stored);
              }
            }
          } catch (apiErr) {
            // Graceful fallback to local stored reviews
          }
        }

        // Filter published or user's own submitted reviews
        let visibleReviews = stored.filter((r) => r.status !== "hidden");

        // Compute metrics matrix
        const totalStatsReviews = visibleReviews.length;
        const ratingCounts = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 };
        let totalRatingSum = 0;
        let withPhotosCount = 0;
        let recommendCount = 0;

        visibleReviews.forEach((r) => {
          if (r.rating >= 1 && r.rating <= 5) {
            ratingCounts[r.rating] = (ratingCounts[r.rating] || 0) + 1;
            totalRatingSum += r.rating;
            if (r.rating >= 4) recommendCount++;
          }
          if (r.productPhotoUrl) withPhotosCount++;
        });

        const averageRating = totalStatsReviews > 0 ? Number((totalRatingSum / totalStatsReviews).toFixed(1)) : 5.0;
        const recommendPercentage = totalStatsReviews > 0 ? Math.round((recommendCount / totalStatsReviews) * 100) : 100;

        const ratingPercentages = {
          5: totalStatsReviews > 0 ? Math.round((ratingCounts[5] / totalStatsReviews) * 100) : 0,
          4: totalStatsReviews > 0 ? Math.round((ratingCounts[4] / totalStatsReviews) * 100) : 0,
          3: totalStatsReviews > 0 ? Math.round((ratingCounts[3] / totalStatsReviews) * 100) : 0,
          2: totalStatsReviews > 0 ? Math.round((ratingCounts[2] / totalStatsReviews) * 100) : 0,
          1: totalStatsReviews > 0 ? Math.round((ratingCounts[1] / totalStatsReviews) * 100) : 0,
        };

        // Apply UI filters
        let displayList = [...visibleReviews];
        if (currentFilter === "photos") displayList = displayList.filter((r) => r.productPhotoUrl);
        if (currentFilter === "5star") displayList = displayList.filter((r) => r.rating === 5);
        if (currentFilter === "4star") displayList = displayList.filter((r) => r.rating === 4);

        if (currentSort === "highest") displayList.sort((a, b) => b.rating - a.rating);
        else if (currentSort === "lowest") displayList.sort((a, b) => a.rating - b.rating);
        else if (currentSort === "helpful") displayList.sort((a, b) => (b.helpfulCount || 0) - (a.helpfulCount || 0));
        else displayList.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

        loadingElem.style.display = "none";
        appContent.style.display = "block";

        renderApp({
          reviews: displayList,
          stats: {
            averageRating,
            totalReviews: totalStatsReviews,
            ratingPercentages,
            ratingCounts,
            recommendPercentage,
            withPhotosCount,
          },
          settings: { badgeText: "VERIFIED BUYER" },
        });
      } catch (err) {
        console.error("Failed to load reviews:", err);
      }
    }

    function renderApp(data) {
      const { reviews, stats, settings } = data;
      const { averageRating, totalReviews, ratingPercentages, ratingCounts, recommendPercentage, withPhotosCount } = stats;

      const photoReviews = reviews.filter((r) => r.productPhotoUrl);
      const votedList = getVotedIds();

      appContent.innerHTML = `
        <!-- Top Summary Score Card -->
        <div class="cr-summary-card">
          <!-- Score Box -->
          <div class="cr-score-box">
            <div class="cr-score-heading">RATINGS &amp; REVIEWS</div>
            <div class="cr-score-number">${averageRating.toFixed(1)}</div>
            <div class="cr-score-stars">${renderStars(Math.round(averageRating))}</div>
            <div class="cr-score-total">${totalReviews} VERIFIED ${totalReviews === 1 ? "REVIEW" : "REVIEWS"}</div>
            <div class="cr-score-recommend">${recommendPercentage}% OF CUSTOMERS RECOMMEND THIS ITEM</div>
          </div>

          <!-- Distribution Bars -->
          <div class="cr-bars">
            ${[5, 4, 3, 2, 1].map((stars) => {
              const pct = ratingPercentages[stars] || 0;
              const count = ratingCounts[stars] || 0;
              return `
                <div class="cr-bar-row" data-rating="${stars}">
                  <span class="cr-bar-label">${stars} STARS</span>
                  <div class="cr-bar-track">
                    <div class="cr-bar-fill" style="width: ${pct}%;"></div>
                  </div>
                  <span class="cr-bar-count">${count}</span>
                </div>
              `;
            }).join("")}
          </div>

          <!-- Write Review Action -->
          <div class="cr-action-box">
            <button type="button" class="cr-btn-write" id="cr-btn-open-modal">
              WRITE A REVIEW
            </button>
          </div>
        </div>

        <!-- Filter & Sort Bar -->
        <div class="cr-filter-bar">
          <div class="cr-filter-tags">
            <button type="button" class="cr-filter-tag ${currentFilter === "all" ? "active" : ""}" data-filter="all">ALL (${totalReviews})</button>
            <button type="button" class="cr-filter-tag ${currentFilter === "photos" ? "active" : ""}" data-filter="photos">WITH PHOTOS (${withPhotosCount})</button>
            <button type="button" class="cr-filter-tag ${currentFilter === "5star" ? "active" : ""}" data-filter="5star">5 STARS (${ratingCounts[5] || 0})</button>
            <button type="button" class="cr-filter-tag ${currentFilter === "4star" ? "active" : ""}" data-filter="4star">4 STARS (${ratingCounts[4] || 0})</button>
          </div>

          <div>
            <select class="cr-sort-select" id="cr-sort-select">
              <option value="newest" ${currentSort === "newest" ? "selected" : ""}>MOST RECENT</option>
              <option value="highest" ${currentSort === "highest" ? "selected" : ""}>HIGHEST RATING</option>
              <option value="lowest" ${currentSort === "lowest" ? "selected" : ""}>LOWEST RATING</option>
              <option value="helpful" ${currentSort === "helpful" ? "selected" : ""}>MOST HELPFUL</option>
            </select>
          </div>
        </div>

        <!-- Reviews Grid -->
        <div class="cr-reviews-grid">
          ${reviews.length === 0 ? `
            <div style="text-align: center; padding: 48px 24px; color: #666666; font-size: 13px; letter-spacing: 0.5px; border: 1px dashed #d1d5db; grid-column: 1 / -1; width: 100%; box-sizing: border-box;">
              NO REVIEWS YET. BE THE FIRST TO WRITE A REVIEW!
            </div>
          ` : reviews.map((r) => {
            const hasVoted = votedList.includes(r.id);
            return `
              <div class="cr-review-card" style="${r.status === 'pending' ? 'border: 1px dashed #b45309; background: #fffdfa;' : ''}">
                <!-- Header -->
                <div class="cr-card-header">
                  <div class="cr-author-info">
                    ${r.customerAvatarUrl ? `
                      <img class="cr-avatar" src="${r.customerAvatarUrl}" alt="${r.customerName}" loading="lazy" />
                    ` : `
                      <div class="cr-avatar-fallback">${(r.customerName || "U").charAt(0)}</div>
                    `}
                    <div class="cr-author-meta">
                      <div class="cr-author-name-row">
                        <span class="cr-author-name">${r.customerName}</span>
                        ${r.status === "pending" ? `
                          <span style="background:#fef3c7; color:#b45309; font-size:9px; font-weight:700; padding:2px 8px; border-radius:9999px; letter-spacing:1px; text-transform:uppercase; display:inline-flex; align-items:center; gap:3px;">
                            ${icons.pending} PENDING APPROVAL
                          </span>
                        ` : (r.verified ? `
                          <span class="cr-badge-verified">${icons.check} ${settings?.badgeText || "VERIFIED BUYER"}</span>
                        ` : "")}
                      </div>
                      <div class="cr-location-tag">
                        <span>${icons.pin} ${[r.city, r.country].filter(Boolean).map((s) => String(s).toUpperCase()).join(", ")}${getCountryFlag(r.country) ? ` ${getCountryFlag(r.country)}` : ""}</span>
                      </div>
                    </div>
                  </div>

                  <div class="cr-rating-date">
                    <div class="cr-stars">${renderStars(r.rating)}</div>
                    <div class="cr-date">${timeAgo(r.createdAt)}</div>
                  </div>
                </div>

                <!-- Body -->
                <div>
                  ${r.title ? `<h4 class="cr-review-title">${r.title.toUpperCase()}</h4>` : ""}
                  <p class="cr-review-body">${r.message}</p>
                </div>

                <!-- Product Photo Attached -->
                ${r.productPhotoUrl ? `
                  <div class="cr-attached-photo">
                    <img class="cr-attached-photo-img" src="${r.productPhotoUrl}" alt="Product photo by ${r.customerName}" data-lightbox-src="${r.productPhotoUrl}" />
                  </div>
                ` : ""}

                <!-- Store Owner Response -->
                ${r.reply ? `
                  <div class="cr-merchant-reply">
                    <div class="cr-merchant-reply-header">
                      <span>STORE OWNER RESPONSE</span>
                    </div>
                    <p class="cr-merchant-reply-body">${r.reply}</p>
                  </div>
                ` : ""}

                <!-- Footer -->
                <div class="cr-card-footer">
                  <div>
                    ${r.productTitle ? `<span>PURCHASED: <strong>${r.productTitle.toUpperCase()}</strong></span>` : ""}
                  </div>
                  <div>
                    <button type="button" class="cr-btn-helpful ${hasVoted ? 'voted' : ''}" data-review-id="${r.id}">
                      ${icons.thumb} HELPFUL (<span class="cr-helpful-count">${r.helpfulCount || 0}</span>)
                    </button>
                  </div>
                </div>
              </div>
            `;
          }).join("")}
        </div>
      `;

      // Event listeners
      const openModalBtn = container.querySelector("#cr-btn-open-modal");
      if (openModalBtn) openModalBtn.addEventListener("click", handleWriteReviewClick);

      container.querySelectorAll("[data-lightbox-src]").forEach((thumb) => {
        thumb.addEventListener("click", () => openLightbox(thumb.dataset.lightboxSrc));
      });

      container.querySelectorAll(".cr-filter-tag[data-filter]").forEach((tag) => {
        tag.addEventListener("click", () => {
          currentFilter = tag.dataset.filter;
          loadReviews();
        });
      });

      container.querySelectorAll(".cr-bar-row").forEach((row) => {
        row.addEventListener("click", () => {
          currentFilter = `${row.dataset.rating}star`;
          loadReviews();
        });
      });

      const sortSelect = container.querySelector("#cr-sort-select");
      if (sortSelect) {
        sortSelect.addEventListener("change", (e) => {
          currentSort = e.target.value;
          loadReviews();
        });
      }

      container.querySelectorAll(".cr-btn-helpful").forEach((hBtn) => {
        hBtn.addEventListener("click", async () => {
          if (hBtn.classList.contains("voted")) return;
          const reviewId = hBtn.dataset.reviewId;
          const countSpan = hBtn.querySelector(".cr-helpful-count");
          const currentCount = parseInt(countSpan.textContent, 10) || 0;
          countSpan.textContent = currentCount + 1;
          hBtn.classList.add("voted");
          saveVotedId(reviewId);

          // Update local persistent storage
          const stored = getStoredReviews();
          const target = stored.find((r) => r.id === reviewId);
          if (target) {
            target.helpfulCount = (target.helpfulCount || 0) + 1;
            saveStoredReviews(stored);
          }

          if (helpfulUrl) {
            try {
              await fetch(helpfulUrl, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ reviewId }),
              });
            } catch (e) {}
          }
        });
      });
    }

    // Submit review form handler (saved permanently into localStorage & sent to backend)
    reviewForm.addEventListener("submit", async (e) => {
      e.preventDefault();

      const submitBtn = container.querySelector("#cr-btn-submit");
      submitBtn.disabled = true;
      submitBtn.textContent = "SUBMITTING REVIEW...";

      const cityInput = container.querySelector("#cr-input-city");
      const countryInput = container.querySelector("#cr-input-country");
      const selectedCity = cityInput ? cityInput.value.trim() : "";
      const selectedCountry = countryInput ? countryInput.value.trim() : "";

      if (!selectedCountry) {
        if (countryInput) {
          countryInput.focus();
          if (countryInput.reportValidity) {
            countryInput.setCustomValidity("Please select your country.");
            countryInput.reportValidity();
            setTimeout(() => countryInput.setCustomValidity(""), 3000);
          }
        }
        submitBtn.disabled = false;
        submitBtn.textContent = "SUBMIT CUSTOMER REVIEW";
        return;
      }

      const phoneInput = container.querySelector("#cr-input-phone");
      const rawPhone = phoneInput ? phoneInput.value.trim() : "";
      const dialCode = getCountryDialCode(selectedCountry);
      let customerPhone = null;
      if (rawPhone) {
        customerPhone = rawPhone.startsWith("+") ? rawPhone : `${dialCode} ${rawPhone}`;
      }

      const newReview = {
        id: "rev-" + Date.now(),
        rating: selectedRating,
        title: container.querySelector("#cr-input-title").value.trim(),
        message: container.querySelector("#cr-input-message").value.trim(),
        customerName: container.querySelector("#cr-input-name").value.trim() || customerName || "Verified Customer",
        customerEmail: container.querySelector("#cr-input-email").value.trim() || customerEmail,
        customerPhone: customerPhone,
        city: selectedCity,
        country: selectedCountry,
        customerAvatarUrl: avatarBase64,
        productPhotoUrl: productPhotoBase64,
        productTitle: productTitle || "Noor-e-Khaas Luxury Article",
        verified: true,
        status: "pending", // Queued for moderation
        helpfulCount: 0,
        createdAt: new Date().toISOString(),
      };

      // 1. Permanently store in persistent localStorage so it NEVER vanishes on refresh!
      const currentStored = getStoredReviews();
      currentStored.unshift(newReview);
      saveStoredReviews(currentStored);

      // 2. Transmit to Supabase PostgreSQL database via Shopify App Proxy / API
      if (reviewsUrl) {
        try {
          const res = await fetch(reviewsUrl, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ shop, productId, productTitle, productHandle, ...newReview }),
          });
          if (res.ok) {
            const data = await res.json();
            if (data && data.review) {
              // Update with permanent record from Supabase
              const stored = getStoredReviews();
              const idx = stored.findIndex((r) => r.id === newReview.id);
              if (idx !== -1) {
                stored[idx] = data.review;
              } else {
                stored.unshift(data.review);
              }
              saveStoredReviews(stored);
            }
          }
        } catch (e) {
          console.warn("Backend sync will retry on next reload", e);
        }
      }

      reviewForm.style.display = "none";
      modalSuccess.style.display = "block";
      reviewForm.reset();
      avatarBase64 = null;
      productPhotoBase64 = null;

      submitBtn.disabled = false;
      submitBtn.textContent = "SUBMIT CUSTOMER REVIEW";

      setTimeout(loadReviews, 500);
    });

    loadReviews();
  }

  function autoMount() {
    const targets = document.querySelectorAll("#shopify-customer-reviews, .shopify-customer-reviews-section");
    targets.forEach((el) => {
      if (!el.dataset.crInitialized) {
        el.dataset.crInitialized = "true";
        initCustomerReviewSection(el);
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", autoMount);
  } else {
    autoMount();
  }

  // Shopify Theme Editor / Customizer Live Preview Listeners
  document.addEventListener("shopify:section:load", autoMount);
  document.addEventListener("shopify:section:select", autoMount);
  document.addEventListener("shopify:block:select", autoMount);
  document.addEventListener("shopify:block:load", autoMount);

  if (window.MutationObserver) {
    const observer = new MutationObserver(() => {
      autoMount();
    });
    observer.observe(document.documentElement || document.body, { childList: true, subtree: true });
  }
})();
